export default "__VITE_ASSET__DO2dvm9U__"